<script>
export default {
  name: 'ForceOrientationMixin',
  data () {
    return {
      isWide: false
    }
  },
  computed: {
    wrongOrientation () {
      if (!this.attributes.forceOrientation) {
        return false
      }
      if (this.attributes.forceOrientation === 'landscape' && !this.isWide) {
        return true
      }
      if (this.attributes.forceOrientation === 'portrait' && this.isWide) {
        return true
      }
      return false
    }
  },
  methods: {
    onForceOrientationResize () {
      this.isWide = window.innerWidth > window.innerHeight
    }
  }
}
</script>
